/**
 * Ctrl/Cmd, shift and non-primary buttons (middle click) belong to the browser
 * so "Open in new tab" works (#4108). Same check as the inbox work-order link.
 *
 * Structural on purpose: MUI's click handler is typed against whatever element
 * the link renders as, and that should still match.
 */
type NavigationClick = {
  ctrlKey: boolean;
  metaKey: boolean;
  shiftKey: boolean;
  button: number;
  target: EventTarget | null;
  currentTarget: EventTarget | null;
  preventDefault: () => void;
};

function isModifiedNavigationClick(event: NavigationClick): boolean {
  return event.ctrlKey || event.metaKey || event.shiftKey || event.button !== 0;
}

const NESTED_INTERACTIVE =
  'a, button, input, textarea, select, [role="button"], [role="menuitem"], [role="menu"]';

/**
 * Plain left click runs `action` and cancels the link's own navigation.
 * Modified clicks return untouched so the real href opens in a new tab.
 * A button or menu inside the link keeps its own action and does not navigate.
 */
export function handlePlainLeftClick(event: NavigationClick, action: () => void): void {
  if (isModifiedNavigationClick(event)) return;
  if (event.target instanceof Element) {
    const interactive = event.target.closest(NESTED_INTERACTIVE);
    if (interactive !== null && interactive !== event.currentTarget) {
      event.preventDefault();
      return;
    }
  }
  event.preventDefault();
  action();
}
